import script from "./UpSports.vue?vue&type=script&setup=true&lang=js"
export * from "./UpSports.vue?vue&type=script&setup=true&lang=js"

import "./UpSports.vue?vue&type=style&index=0&id=0f35baad&scoped=true&lang=css"

import exportComponent from "/home/runner/work/helixpay-website/helixpay-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f35baad"]])

export default __exports__